import {Stack, styled} from '@mui/material';
import {Navigate, Route, Routes} from 'react-router-dom';

import {Sizes} from '@constants/sizes.constants';

import {
  AdminRoutes,
  AuditDetailsRoutes,
  ClientDetailsRoutes,
  ClientsRoutes,
  ClientUnitDetailsRoutes,
  DashboardRoutes,
  InvoicesRoutes,
  OfferFollowUpDetailsRoutes,
  OperationsRoutes,
  SettingsRoutes,
  SupplierDetailsRoutes,
  SuppliersRoutes,
  SupplierUnitDetailsRoutes,
} from '@utils/routes.utils';
import LeftBarComponent from '@components/leftBar/LeftBar.component';

import DashboardScreen from '@screens/admin/dashboard/Dashboard.screen';
import FinanceTab from '@screens/admin/dashboard/stats/finance/Finance.tab';
import OperationsTab from '@screens/admin/dashboard/stats/operations/Operations.tab';
import StatsTab from '@screens/admin/dashboard/stats/Stats.tab';

import ClientsScreen from '@screens/admin/clients/Clients.screen';
import ClientDetailsScreen from '@screens/admin/clients/details/ClientDetails.screen';
import ClientUnitsTab from '@screens/admin/clients/details/clientUnits/ClientUnits.tab';
import ManageClientUnitScreen
  from '@screens/admin/clients/details/clientUnits/details/manageClientUnit/ManageClientUnit.screen';
import ClientContractedServicesTab from '@screens/admin/clients/details/contractedServices/ClientContractedServices.tab';
import ClientDetailsDocumentsTab from '@screens/admin/clients/details/documents/Documents.tab';
import ClientDetailsHeadOfficeTab from '@screens/admin/clients/details/headOffice/HeadOffice.tab';
import ClientsListTab from '@screens/admin/clients/list/ClientsList.tab';
import ClientsServicesTab from '@screens/admin/clients/services/ClientsServices.tab';
import ClientsUnitsTab from '@screens/admin/clients/units/ClientsUnits.tab';

import ManageCatalogServiceDrawer from '@screens/admin/suppliers/details/catalog/manageService/ManageService.drawer';
import SupplierCatalogTab from '@screens/admin/suppliers/details/catalog/SupplierCatalog.tab';
import SupplierContractedServicesTab
  from '@screens/admin/suppliers/details/contractedServices/SupplierContractedServices.tab';
import SupplierDetailsDocumentsTab from '@screens/admin/suppliers/details/documents/Documents.tab';
import SupplierDetailsHeadOfficeTab from '@screens/admin/suppliers/details/headOffice/HeadOffice.tab';
import SupplierDetailsScreen from '@screens/admin/suppliers/details/SupplierDetails.screen';
import ManageSupplierUnitScreen
  from '@screens/admin/suppliers/details/supplierUnits/details/manageSupplierUnit/ManageSupplierUnit.screen';
import SupplierUnitsTab from '@screens/admin/suppliers/details/supplierUnits/SupplierUnits.tab';
import SuppliersListTab from '@screens/admin/suppliers/list/SuppliersList.tab';
import SuppliersServicesTab from '@screens/admin/suppliers/services/SuppliersServices.tab';
import SuppliersScreen from '@screens/admin/suppliers/Suppliers.screen';
import SuppliersUnitsTab from '@screens/admin/suppliers/units/SuppliersUnits.tab';

import OperationsExecutionsTab from '@screens/admin/operations/executions/Executions.tab';
import ManageExecutionDrawer from '@screens/admin/operations/executions/manageExecution/ManageExecution.drawer';
import ManageIssueDrawer from '@screens/admin/operations/noncompliance/manageIssue/ManageIssue.drawer';
import NoncomplianceTab from '@screens/admin/operations/noncompliance/Noncompliance.tab';
import OperationsScreen from '@screens/admin/operations/Operations.screen';

import BillsTab from '@screens/admin/invoices/bills/Bills.tab';
import InvoicesExecutionsTab from '@screens/admin/invoices/executions/Executions.tab';
import InvoicesScreen from '@screens/admin/invoices/Invoices.screen';
import PurchaseStatementDetailsScreen
  from '@screens/admin/invoices/purchaseStatement/details/PurchaseStatementDetails.screen';
import PurchaseStatementTab from '@screens/admin/invoices/purchaseStatement/PurchaseStatement.tab';

import ReportsScreen from '@screens/admin/reports/Reports.screen';

import DocumentsScreen from '@screens/admin/documents/Document.screen';
import ManageDocumentDrawer from '@screens/admin/documents/manageDocuments/ManageDocument.drawer';

import ClientsContractsTab from '@screens/admin/clients/contracts/ClientsContracts.tab';
import ClientUnitDetailsScreen from '@screens/admin/clients/details/clientUnits/details/ClientUnitDetails.screen';
import ClientUnitContractedServicesTab
  from '@screens/admin/clients/details/clientUnits/details/contractedServices/ClientUnitContractedServices.tab';
import ManageServiceIndex from '@screens/admin/clients/details/contractedServices/manageService/ManageService.index';
import BillDetailsScreen from '@screens/admin/invoices/bills/details/BillDetails.screen';
import SendBillsModal from '@screens/admin/invoices/bills/send/SendBills.modal';
import JobInvoiceDetailsModal from '@screens/admin/invoices/invoicesValidation/details/JobInvoiceDetails.modal';
import InvoicesValidationTab from '@screens/admin/invoices/invoicesValidation/InvoicesValidation.tab';
import AddBatchExecutionsIndex, {
  AddBatchProvenance
} from '@screens/admin/operations/executions/addExecutions/AddBatchExecutions.index';
import ManageGenerateReportDrawer from '@screens/admin/reports/generateReport/GenerateReport.drawer';
import ContainersTab from '@screens/admin/settings/containers/Containers.tab';
import IndexationTab from '@screens/admin/settings/indexation/Indexation.tab';
import ManageContainerModal from '@screens/admin/settings/containers/manageContainer/ManageContainer.modal';
import ManagePriceCatalog from '@screens/admin/settings/priceCatalog/managePriceCatalog/ManagePriceCatalog';
import PriceCatalogTab from '@screens/admin/settings/priceCatalog/PriceCatalog.tab';
import PriceCatalogDetailsView from '@screens/admin/settings/priceCatalog/PriceCatalogDetailsView';
import ManageServiceKindModal from '@screens/admin/settings/serviceTypes/manageServiceKind/ManageServiceKind.modal';
import ServiceTypesTab from '@screens/admin/settings/serviceTypes/ServiceTypes.tab';
import ManageUserDrawer from '@screens/admin/settings/users/manageUser/ManageUser.drawer';
import UsersTab from '@screens/admin/settings/users/Users.tab';
import ManageWasteModal from '@screens/admin/settings/waste/manageWaste/ManageWaste.modal';
import ManageWasteFamilyModal from '@screens/admin/settings/waste/manageWasteFamily/ManageWasteFamily.modal';
import WasteTab from '@screens/admin/settings/waste/Waste.tab';
import AuditsScreen from './audits/Audits.screen';
import AddPreAuditDataDrawer from './audits/pre-audit/AddPreAuditData.drawer';
import HistoryTab from './settings/history/History.tab';
import HistoryDetails from './settings/history/HistoryDetails';

import ContainerDetails from '@screens/admin/audits/audits-offer-follow-up/components/ContainerDetails.drawer';
import OfferDetails from '@screens/admin/audits/audits-offer-follow-up/components/OfferDetails.drawer';
import OfferDetailsStatus from '@screens/admin/audits/audits-offer-follow-up/components/OfferDetailsStatus.drawer';
import DocumentsTabUnits from '@screens/admin/clients/details/clientUnits/details/documents/Documents.tab';
import ClientsUnitDetailsUsersTab from '@screens/admin/clients/details/clientUnits/details/users/ClientUnitDetailsUsers';
import CreateServiceDrawer from '@screens/admin/clients/details/contractedServices/manageService/CreateService.drawer';
import ClientsDetailsUsersTab from '@screens/admin/clients/details/users/ClientsDetailsUsersTab';
import AccountTab from '@screens/admin/settings/account/Account.tab';
import ManageAccountDrawer from '@screens/admin/settings/account/manageAccount/ManageAccount.drawer';
import ChangeRateTab from '@screens/admin/settings/changeRate/ChangeRate.tab';
import InterfaceTab from '@screens/admin/settings/interface/Interface.tab';
import InvoicingPeriodTab from '@screens/admin/settings/invoicingPeriod/InvoicingPeriod.tab';
import IssueKindsTab from '@screens/admin/settings/issueKinds/IssueKinds.tab';
import OrganisationConfigTab from '@screens/admin/settings/organisationConfig/OrganisationConfig.tab';
import SupplierUnitDetailsScreen
  from '@screens/admin/suppliers/details/supplierUnits/details/SupplierUnitDetails.screen';
import SupplierUnitDetailsUsersTab
  from '@screens/admin/suppliers/details/supplierUnits/details/users/SupplierUnitDetailsUsers';
import DocumentsTabSupplierUnit from '@screens/admin/suppliers/details/supplierUnits/documents/Documents.tab';
import SupplierDetailsUsersTab from '@screens/admin/suppliers/details/users/SupplierDetailsUsersTab';
import {InvoicingSource} from '@store/common/organisation.model';
import AuditDetailsScreen from './audits/audit-detail/AuditDetails.screen';
import AuditTab from './audits/audit-detail/tabs/Audit.tab';
import AuditOfferTab from './audits/audit-detail/tabs/AuditOffer.tab';
import AuditPrecoTab from './audits/audit-detail/tabs/AuditPreco.tab';
import AuditsOfferActivation from './audits/audit-detail/tabs/AuditsOfferActivation.tab';
import AuditsOfferFollowUp from './audits/audit-detail/tabs/AuditsOfferFollowUp.tab';
import AuditsOfferFormalization from './audits/audit-detail/tabs/AuditsOfferFormalization.tab';
import PreAuditTab from './audits/audit-detail/tabs/PreAudit.tab';
import AddAuditDataDrawer from './audits/audit/AddAuditData.drawer';
import AddOfferDrawer from './audits/audits-offer/AddOffer.drawer';
import AddPrecoContainerDrawer from './audits/preco/AddPrecoContainer.drawer';
import ManageContractDrawer from '@screens/admin/clients/details/contracts/manageContract/ManageContract.drawer';

const Container = styled(Stack)`
    height: 100%;
    padding-left: ${Sizes.leftBar}px;
`;

const Admin = () => {
  return (
    <Container>

      <LeftBarComponent/>
      <Routes>
        <Route path={AdminRoutes.DASHBOARD} element={<DashboardScreen/>}>
          <Route path={DashboardRoutes.STATS} element={<StatsTab/>}>
            <Route path={DashboardRoutes.FINANCE} element={<FinanceTab/>}/>
            <Route path={DashboardRoutes.OPERATIONS} element={<OperationsTab/>}/>
            <Route index element={<Navigate replace to={DashboardRoutes.FINANCE}/>}/>
          </Route>
          <Route path={DashboardRoutes.RANKS}/>
          <Route index element={<Navigate replace to={DashboardRoutes.STATS}/>}/>
        </Route>
        <Route path={AdminRoutes.CLIENTS}>
          <Route path=":clientId" element={<ClientDetailsScreen/>}>
            <Route path={ClientDetailsRoutes.ORGANISATION} element={<ClientDetailsHeadOfficeTab/>}/>
            <Route path={ClientDetailsRoutes.CLIENT_UNITS} element={<ClientUnitsTab/>}/>
            <Route path={ClientDetailsRoutes.CONTRACTS} element={<ClientsContractsTab/>}>
              <Route path="services/:serviceId" element={<ManageServiceIndex fromClient/>}/>
            </Route>
            <Route path={ClientDetailsRoutes.CONTRACTED_SERVICES} element={<ClientContractedServicesTab/>}>
              <Route path="add" element={<ManageServiceIndex isCreation fromClient/>}/>
              <Route path=":serviceId" element={<ManageServiceIndex fromClient/>}/>
            </Route>
            <Route path={ClientDetailsRoutes.DOCUMENTS} element={<ClientDetailsDocumentsTab/>}>
              <Route path="add" element={<ManageDocumentDrawer fromClient isCreation/>}/>
              <Route path=":documentId" element={<ManageDocumentDrawer fromClient/>}/>
            </Route>
            <Route path={ClientDetailsRoutes.USERS} element={<ClientsDetailsUsersTab/>}/>
            <Route index element={<Navigate replace to={ClientDetailsRoutes.ORGANISATION}/>}/>
          </Route>
        </Route>
        <Route path={`${AdminRoutes.CLIENTS}/:clientId/${ClientDetailsRoutes.CLIENT_UNITS}`}>
          <Route path=":clientUnitId" element={<ClientUnitDetailsScreen/>}>
            <Route path={ClientUnitDetailsRoutes.CLIENT_UNIT} element={<ManageClientUnitScreen/>}/>
            <Route path={ClientUnitDetailsRoutes.CONTRACTS} element={<ClientsContractsTab/>}/>
            <Route path={ClientUnitDetailsRoutes.CONTRACTED_SERVICES} element={<ClientUnitContractedServicesTab/>}>
              <Route path=":serviceId" element={<ManageServiceIndex fromClientUnit/>}/>
            </Route>
            <Route path={ClientUnitDetailsRoutes.DOCUMENTS} element={<DocumentsTabUnits/>}>
              <Route path="add" element={<ManageDocumentDrawer fromClient isUnitClient isCreation/>}/>
              <Route path=":documentId" element={<ManageDocumentDrawer fromClient isUnitClient/>}/>
            </Route>
            <Route path={ClientUnitDetailsRoutes.USERS} element={<ClientsUnitDetailsUsersTab/>}/>
            <Route index element={<Navigate replace to={ClientUnitDetailsRoutes.CLIENT_UNIT}/>}/>
          </Route>
          <Route path="add" element={<ManageClientUnitScreen isCreation/>}/>
        </Route>
        <Route path={AdminRoutes.CLIENTS} element={<ClientsScreen/>}>
          <Route path={ClientsRoutes.LIST} element={<ClientsListTab/>}/>
          <Route path={ClientsRoutes.UNITS} element={<ClientsUnitsTab/>}/>
          <Route path={ClientsRoutes.CONTRACTS} element={<ClientsContractsTab/>}>
            <Route path=":contractId" element={<ManageContractDrawer/>}/>
            <Route path="services/:serviceId" element={<ManageServiceIndex fromClient/>}/>
          </Route>
          <Route path={ClientsRoutes.SERVICES} element={<ClientsServicesTab/>}>
            <Route path="add" element={<CreateServiceDrawer/>}/>
            <Route path=":serviceId" element={<ManageServiceIndex fromClient/>}/>
          </Route>
          <Route index element={<Navigate replace to={ClientsRoutes.LIST}/>}/>
        </Route>
        <Route path={`${AdminRoutes.CLIENTS}/${ClientsRoutes.UNITS}`}>
          <Route path=":clientUnitId" element={<ClientUnitDetailsScreen/>}>
            <Route path={ClientUnitDetailsRoutes.CLIENT_UNIT} element={<ManageClientUnitScreen/>}/>
            <Route path={ClientUnitDetailsRoutes.CONTRACTS} element={<ClientsContractsTab/>}>
              <Route path="services/:serviceId" element={<ManageServiceIndex fromClient/>}/>
            </Route>
            <Route path={ClientUnitDetailsRoutes.USERS} element={<ClientsUnitDetailsUsersTab/>}/>
            <Route path={ClientUnitDetailsRoutes.CONTRACTED_SERVICES} element={<ClientUnitContractedServicesTab/>}>
              <Route path=":serviceId" element={<ManageServiceIndex fromClientUnit/>}/>
            </Route>
            <Route path={ClientUnitDetailsRoutes.DOCUMENTS} element={<DocumentsTabUnits/>}>
              <Route path="add" element={<ManageDocumentDrawer fromClient isUnitClient isCreation/>}/>
              <Route path=":documentId" element={<ManageDocumentDrawer fromClient isUnitClient/>}/>
            </Route>
            <Route index element={<Navigate replace to={ClientUnitDetailsRoutes.CLIENT_UNIT}/>}/>
          </Route>
        </Route>
        <Route path={AdminRoutes.SUPPLIERS}>
          <Route path=":supplierId" element={<SupplierDetailsScreen/>}>
            <Route path={SupplierDetailsRoutes.ORGANISATION} element={<SupplierDetailsHeadOfficeTab/>}/>
            <Route path={SupplierDetailsRoutes.SUPPLIER_UNITS} element={<SupplierUnitsTab/>}/>
            <Route path={SupplierDetailsRoutes.CATALOG} element={<SupplierCatalogTab/>}>
              <Route path=":serviceId" element={<ManageCatalogServiceDrawer fromSupplier/>}/>
            </Route>
            <Route path={SupplierDetailsRoutes.CONTRACTED_SERVICES}
                   element={<SupplierContractedServicesTab/>}>
              <Route path="add" element={<ManageServiceIndex isCreation/>}/>
              <Route path=":serviceId" element={<ManageServiceIndex/>}/>
            </Route>
            <Route path={SupplierDetailsRoutes.DOCUMENTS} element={<SupplierDetailsDocumentsTab/>}>
              <Route path="add" element={<ManageDocumentDrawer fromSupplier isCreation/>}/>
              <Route path=":documentId" element={<ManageDocumentDrawer fromSupplier/>}/>
            </Route>
            <Route path={SupplierDetailsRoutes.USERS} element={<SupplierDetailsUsersTab/>}/>
            <Route index element={<Navigate replace to={SupplierDetailsRoutes.ORGANISATION}/>}/>
          </Route>
        </Route>
        <Route path={`${AdminRoutes.SUPPLIERS}/:supplierId/${SupplierDetailsRoutes.SUPPLIER_UNITS}`}>
          <Route path=":supplierUnitId" element={<SupplierUnitDetailsScreen/>}>
            <Route path={SupplierDetailsRoutes.SUPPLIER_UNITS} element={<ManageSupplierUnitScreen/>}/>
            <Route path={ClientUnitDetailsRoutes.USERS} element={<SupplierUnitDetailsUsersTab/>}/>
            <Route path={SupplierDetailsRoutes.DOCUMENTS} element={<DocumentsTabSupplierUnit/>}>
              <Route path="add" element={<ManageDocumentDrawer fromSupplier isUnitSupplier isCreation/>}/>
              <Route path=":documentId" element={<ManageDocumentDrawer fromSupplier isUnitSupplier/>}/>
            </Route>
            <Route index element={<Navigate replace to={SupplierDetailsRoutes.SUPPLIER_UNITS}/>}/>
          </Route>
        </Route>
        <Route path={AdminRoutes.SUPPLIERS} element={<SuppliersScreen/>}>
          <Route path={SuppliersRoutes.LIST} element={<SuppliersListTab/>}/>
          <Route path={SuppliersRoutes.UNITS} element={<SuppliersUnitsTab/>}/>
          <Route path={SuppliersRoutes.SERVICES} element={<SuppliersServicesTab/>}>
            <Route path="add" element={<ManageCatalogServiceDrawer isCreation/>}/>
            <Route path=":serviceId" element={<ManageCatalogServiceDrawer/>}/>
          </Route>
          <Route index element={<Navigate replace to={SuppliersRoutes.LIST}/>}/>
        </Route>
        <Route path={`${AdminRoutes.SUPPLIERS}/${SuppliersRoutes.UNITS}`}>
          <Route path=":supplierUnitId" element={<SupplierUnitDetailsScreen/>}>
            <Route path={SupplierUnitDetailsRoutes.SUPPLIER_UNIT} element={<ManageSupplierUnitScreen/>}/>
            <Route path={ClientUnitDetailsRoutes.USERS} element={<SupplierUnitDetailsUsersTab/>}/>
            <Route path={SupplierDetailsRoutes.DOCUMENTS} element={<DocumentsTabSupplierUnit/>}>
              <Route path="add" element={<ManageDocumentDrawer fromSupplier isUnitSupplier isCreation/>}/>
              <Route path=":documentId" element={<ManageDocumentDrawer fromSupplier isUnitSupplier/>}/>
            </Route>
            <Route index element={<Navigate replace to={SupplierUnitDetailsRoutes.SUPPLIER_UNIT}/>}/>
          </Route>
        </Route>
        <Route path={AdminRoutes.OPERATIONS} element={<OperationsScreen/>}>
          <Route path={OperationsRoutes.EXECUTIONS} element={<OperationsExecutionsTab/>}>
            <Route path="add" element={<ManageExecutionDrawer isCreation/>}/>
            <Route path="add-batch" element={<AddBatchExecutionsIndex from={AddBatchProvenance.EXEC}/>}/>
            <Route path=":executionId" element={<ManageExecutionDrawer/>}>
              <Route path="add" element={<ManageIssueDrawer isCreation fromExecution/>}/>
              <Route path="add-execution" element={<ManageExecutionDrawer isCreation/>}/>
              <Route path="issue/:issueId" element={<ManageIssueDrawer fromExecution/>}/>
            </Route>
          </Route>
          <Route path={OperationsRoutes.NONCOMPLIANCE} element={<NoncomplianceTab/>}>
            <Route path="add" element={<ManageIssueDrawer isCreation/>}/>
            <Route path=":issueId" element={<ManageIssueDrawer/>}/>
            <Route path={`:issueId/${OperationsRoutes.EXECUTIONS}/:executionId`}
                   element={<ManageExecutionDrawer/>}/>
          </Route>
          <Route index element={<Navigate replace to={OperationsRoutes.EXECUTIONS}/>}/>
        </Route>
        <Route path={AdminRoutes.INVOICES} element={<InvoicesScreen/>}>
          <Route path={InvoicesRoutes.EXECUTIONS}
                 element={<InvoicesExecutionsTab invoicingSource={InvoicingSource.MOS}/>}>
            <Route path="add" element={<ManageExecutionDrawer isCreation/>}/>
            <Route path="add-batch"
                   element={<AddBatchExecutionsIndex from={AddBatchProvenance.EXEC_LINE}/>}/>
            <Route path=":executionId" element={<ManageExecutionDrawer/>}/>
          </Route>
          <Route path={InvoicesRoutes.EXECUTIONS_NESSY}
                 element={<InvoicesExecutionsTab invoicingSource={InvoicingSource.NESSY}/>}>
            <Route path="add" element={<ManageExecutionDrawer isCreation/>}/>
            <Route path="add-batch" element={<AddBatchExecutionsIndex from={AddBatchProvenance.EXEC_LINE}/>}/>
            <Route path=":executionId" element={<ManageExecutionDrawer/>}>
              <Route path="add-execution" element={<ManageExecutionDrawer isCreation/>}/>
            </Route>
          </Route>
          <Route path={InvoicesRoutes.PURCHASE_STATEMENT} element={<PurchaseStatementTab/>}/>
          <Route path={InvoicesRoutes.INVOICES_VALIDATION} element={<InvoicesValidationTab/>}>
            <Route path=":jobInvoiceId" element={<JobInvoiceDetailsModal/>}/>
          </Route>
          <Route path={InvoicesRoutes.BILLS} element={<BillsTab/>}>
            <Route path="send" element={<SendBillsModal/>}/>
          </Route>
          <Route index element={<Navigate replace to={InvoicesRoutes.EXECUTIONS}/>}/>
        </Route>
        <Route path={`${AdminRoutes.INVOICES}/${InvoicesRoutes.PURCHASE_STATEMENT}`}>
          <Route path=":statementId" element={<PurchaseStatementDetailsScreen/>}>
            <Route path=":executionId" element={<ManageExecutionDrawer readOnly/>}/>
          </Route>
        </Route>
        <Route path={`${AdminRoutes.INVOICES}/${InvoicesRoutes.BILLS}`}>
          <Route path=":invoiceId" element={<BillDetailsScreen/>}>
            <Route path=":executionId" element={<ManageExecutionDrawer readOnly/>}/>
          </Route>
        </Route>
        <Route path={`${AdminRoutes.INVOICES}/${InvoicesRoutes.INVOICES_VALIDATION}/:jobInvoiceId`}>
          <Route path=":invoiceId" element={<BillDetailsScreen/>}>
            <Route path=":executionId" element={<ManageExecutionDrawer readOnly/>}/>
          </Route>
        </Route>
        <Route path={`${AdminRoutes.INVOICES}/${InvoicesRoutes.EXECUTIONS}`}>
          <Route path="generate" element={<PurchaseStatementDetailsScreen isCreation/>}>
            <Route path=":executionId" element={<ManageExecutionDrawer readOnly/>}/>
          </Route>
        </Route>
        <Route path={AdminRoutes.REPORTS} element={<ReportsScreen/>}>
          <Route path="generate" element={<ManageGenerateReportDrawer isCreation/>}/>
        </Route>
        <Route path={AdminRoutes.DOCUMENTS} element={<DocumentsScreen/>}>
          <Route path="add" element={<ManageDocumentDrawer isCreation/>}/>
          <Route path=":documentId" element={<ManageDocumentDrawer/>}/>
        </Route>
        <Route path={AdminRoutes.AUDITS} element={<AuditsScreen/>}>
          <Route path="add" element={<ManageDocumentDrawer isCreation/>}/>
          <Route path=":documentId" element={<ManageDocumentDrawer/>}/>
        </Route>
        <Route path={AdminRoutes.AUDITS}>
          <Route path=":auditId" element={<AuditDetailsScreen/>}>
            <Route path={AuditDetailsRoutes.PRE_AUDIT} element={<PreAuditTab/>}>
              <Route path="add-data" element={<AddPreAuditDataDrawer/>}/>
            </Route>
            <Route path={AuditDetailsRoutes.AUDIT} element={<AuditTab/>}>
              <Route path="add-data" element={<AddAuditDataDrawer/>}/>
            </Route>
            <Route path={AuditDetailsRoutes.PRECO} element={<AuditPrecoTab/>}>
              <Route path={'add-container'} element={<AddPrecoContainerDrawer/>}/>
              <Route path={'optimization-container'} element={<AddPrecoContainerDrawer isOptimization/>}/>
            </Route>
            <Route path={AuditDetailsRoutes.OFFER} element={<AuditOfferTab/>}>
              <Route path="add-audit-offer" element={<AddOfferDrawer/>}/>
            </Route>
            <Route path={AuditDetailsRoutes.OFFER_FOLLOWUP} element={<AuditsOfferFollowUp/>}>
              <Route path={`${OfferFollowUpDetailsRoutes.DETAILS_OFFER}/:offerId`} element={<OfferDetails/>}/>
              <Route path={`${OfferFollowUpDetailsRoutes.DETAILS_OFFERSTATUS}/:offerStatusId`}
                     element={<OfferDetailsStatus/>}/>
              <Route path="details-container" element={<ContainerDetails/>}/>
              <Route path="details-container/:id" element={<ContainerDetails/>}/>
            </Route>
            <Route path={AuditDetailsRoutes.OFFER_FORMALIZATION} element={<AuditsOfferFormalization/>}>
              {/* Add routes for offerFomalization */}
            </Route>
            <Route path={AuditDetailsRoutes.OFFER_ACTIVATION} element={<AuditsOfferActivation/>}>
              {/* Add routes for offerActivation */}
            </Route>
            <Route index element={<Navigate replace to={AuditDetailsRoutes.PRE_AUDIT}/>}/>
          </Route>
          <Route path=":templateId/template" element={<AuditDetailsScreen isTemplate/>}>
            <Route path={AuditDetailsRoutes.PRE_AUDIT} element={<PreAuditTab isTemplate/>}/>
            <Route path={AuditDetailsRoutes.AUDIT} element={<AuditTab isTemplate/>}/>
            {/*<Route path={AuditDetailsRoutes.PRECO} element={<AuditPrecoTab isTemplate/>}/>*/}
            {/*<Route path={AuditDetailsRoutes.OFFER} element={<AuditOfferTab isTemplate/>}/>*/}
            <Route index element={<Navigate replace to={AuditDetailsRoutes.PRE_AUDIT}/>}/>
          </Route>
        </Route>
        <Route path={AdminRoutes.AUDITS}>
          <Route path=":auditId" element={<AuditDetailsScreen/>}/>
        </Route>
        <Route path={AdminRoutes.SETTINGS}>
          <Route path="price-catalog/:priceCatalogId" element={<PriceCatalogDetailsView/>}/>
          <Route path={SettingsRoutes.USERS} element={<UsersTab/>}>
            <Route path=":userId" element={<ManageUserDrawer/>}/>
          </Route>
          <Route path={SettingsRoutes.WASTE} element={<WasteTab/>}>
            <Route path="add" element={<ManageWasteFamilyModal isCreation/>}/>
            <Route path=":wasteFamilyId" element={<ManageWasteFamilyModal/>}/>
            <Route path=":wasteFamilyId/add" element={<ManageWasteModal isCreation/>}/>
            <Route path=":wasteFamilyId/:wasteId" element={<ManageWasteModal/>}/>
          </Route>
          <Route path={SettingsRoutes.CONTAINERS} element={<ContainersTab/>}>
            <Route path="add" element={<ManageContainerModal isCreation/>}/>
            <Route path=":containerId" element={<ManageContainerModal/>}/>
          </Route>
          <Route path={SettingsRoutes.PRICE_CATALOG} element={<PriceCatalogTab/>}>
            <Route path="add" element={<ManagePriceCatalog isCreation/>}/>
            {/*<Route path="edit/:priceCatalogId" element={<EditPriceCatalog/>}/>*/}
          </Route>
          <Route path={SettingsRoutes.SERVICE_KINDS} element={<ServiceTypesTab/>}>
            <Route path=":serviceKindId" element={<ManageServiceKindModal/>}/>
          </Route>
          <Route path={SettingsRoutes.HISTORIES} element={<HistoryTab/>}/>
          <Route path={`${SettingsRoutes.HISTORY}/:historyId`} element={<HistoryDetails/>}/>
          <Route path={SettingsRoutes.ACCOUNTING} element={<AccountTab/>}>
            <Route path="add" element={<ManageAccountDrawer isCreation/>}/>
            <Route path=":accountId" element={<ManageAccountDrawer/>}/>
          </Route>
          <Route path={SettingsRoutes.HISTORIES} element={<HistoryTab/>}/>
          <Route path={SettingsRoutes.ISSUE_KINS} element={<IssueKindsTab/>}/>
          <Route path={SettingsRoutes.CHANGE_RATE} element={<ChangeRateTab/>}/>
          <Route path={SettingsRoutes.INVOICING_PERIOD} element={<InvoicingPeriodTab/>}/>
          <Route path={SettingsRoutes.INTERFACE} element={<InterfaceTab/>}/>
          <Route path={SettingsRoutes.ORGANISATIONS_CONFIG} element={<OrganisationConfigTab/>}/>
          <Route path={SettingsRoutes.INDEXATION} element={<IndexationTab/>}/>
          <Route index element={<Navigate replace to={SettingsRoutes.USERS}/>}/>
        </Route>

        <Route path="*" element={<Navigate replace to={AdminRoutes.DASHBOARD}/>}/>
      </Routes>
    </Container>
  );
};

export default Admin;
